import { ITableConfig, TableColumnType, UITableColumnCellType } from '@shared/ui';

export const tableConfig: ITableConfig = {
  paginationType: 'server-side',
  columns: [
    {
      type: TableColumnType.Order,
      width: '70px',
    },
    {
      title: 'Внешный id (parkingUid)',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'externalId',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Адрес',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'address',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Локация (lat, long)',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'location.y',
      },
      subName: {
        type: UITableColumnCellType.Text,
        fieldName: 'location.x',
      },
      type: TableColumnType.Basic,
    },
    {
      title: 'Парковочные места',
      name: {
        type: UITableColumnCellType.Text,
        fieldName: 'totalSpots',
      },
      align: 'right',
      type: TableColumnType.Basic,
    },
    {
      type: TableColumnType.Actions,
      width: '100px',
      buttons: [
        {
          type: 'details',
          icon: 'file-text',
        },
        // {
        //   type: 'delete',
        // },
      ],
      align: 'right',
    },
  ],
};
